import React from 'react'
import PropTypes from 'prop-types'

export default function ValidatedInput({ label, id, type, hasError, onChange, errorText, description, value, maxLength }) {
    return (
        <div>
            <label htmlFor={id}>{label}</label>
            {hasError ? (
                <>
                <input
                type={type}
                className="form-control"
                style={{ border: "2px solid rgba(204, 0, 0, 0.2)" } }
                id={id}
                onChange={onChange} 
                value={value}
                maxLength={maxLength}/>
                <div className="alert alert-danger" role="alert" style={{ padding: "0.2rem 0.2rem" }}>
                    {errorText}
                </div>
                </>
            ) : (
                <input
                    type={type}
                    className="form-control"
                    id={id}
                    onChange={onChange}
                    value={value}
                    maxLength={maxLength} />
            )}

            {description &&
                <small id={id + "help"} className="form-text text-muted">{description}</small>
            }

        </div>
    )
}

ValidatedInput.propTypes = {

    hasError: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    errorText: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    description: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    maxLength: PropTypes.number
}
